import React from "react";

import { motion } from "framer-motion";

import Typography from "@mui/material/Typography";

import StatusIcon from "../StatusIcon";

import CloseIcon from "../../assets/icons/Close.svg";
import { anim, modalIn, modalUp } from "../Animations/utils";

interface ModalProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
  status?: "idle" | "loading" | "success" | "error";
  onDismiss?: () => void;
}

const Modal = (props: ModalProps) => {
  const { title, message, status, onDismiss } = props;

  return (
    <div className="main-modal">
      <motion.div {...anim(modalIn)} className="main-modal__background" />
      <motion.div {...anim(modalUp)} className="main-modal__content">
        <div className="text-center mt-5">
          {title && (
            <Typography variant="h1" className={`text-${status}`}>
              {title}
            </Typography>
          )}
          {message && (
            <Typography variant="h2" className="mt-5">
              {message}
            </Typography>
          )}
        </div>
        <StatusIcon status={status} />
        {status !== "loading" && (
          <div className="main-modal__close" onClick={onDismiss}>
            <CloseIcon width="5.5rem" />
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default React.memo(Modal);
